import { frontendURL } from 'dashboard/helper/URLHelper';
import TeamIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/team'),
    name: 'team_dashboard_index',
    component: TeamIndex,
    meta: {
      // Inviting teammates and shaping teams are account administration, so the
      // page is gated the same way the agent and team settings screens are.
      permissions: ['administrator'],
    },
  },
];
